import { DateTimeUtils, NavigationModule } from 'UI-Dash-Commons-UI';
import DocsMenuSection from '../types/DocsMenuSection';
import TableContents from '../types/TableContents';
import {
    DSP_GDPR_DELETED_DEVICE_IDS_API_COMPONENT_TABLE_CONTENTS,
    DSP_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    DSP_REPORTING_COMPONENT_TABLE_CONTENTS,
    DSP_TESTING_COMPONENT_TABLE_CONTENTS,
} from './TableContentsSectionWrapper';

// TODO all routes maps should be passed from the back-end and not be statically defined in this utils
export const DOCS_BOTTOM_MENU: Array<DocsMenuSection> =
    [
        {
            displayName: 'Terms',
            id: '_terms',
            isPage: true,
            url: 'https://www.applovin.com/terms',
            children: [],
        },
        {
            displayName: 'Privacy',
            id: '_privacy',
            isPage: true,
            url: 'https://www.applovin.com/privacy',
            children: [],
        },
        {
            displayName: 'Support',
            id: '_support',
            isPage: true,
            url: 'https://www.applovin.com/support',
            children: [],
        },
        {
            displayName: 'Your Privacy Choices',
            id: '_privacy_ca_residents',
            isPage: true,
            url: 'https://www.applovin.com/privacy-ca-residents',
            icon: {
                iconSrc: require( `../images/menu/privacy-choices-opt-out-icon.svg` ),
                iconAlt: 'California Consumer Privacy Act (CCPA) Opt-Out Icon',
            },
            children: [],
        },
        {
            displayName: 'Cookies Settings',
            id: '_one_trust_sdk',
            isPage: true,
            url: NavigationModule.constants.ONE_TRUST_SDK_URL,
            children: [],
        },
        {
            displayName: 'EULA',
            id: '_eula',
            isPage: true,
            url: 'https://www.applovin.com/eula',
            children: [],
        },
        {
            displayName: 'DMCA',
            id: '_dmca',
            isPage: true,
            url: 'https://www.applovin.com/dmca/',
            children: [],
        }
    ];

export const DOCS_BOTTOM_MENU_TITLE = `Copyright ${DateTimeUtils.getUtcToday().getUTCFullYear()} by AppLovin`;

export const DOCS_RIGHT_SIDE_MENU_TABLE_CONTENT: Array<TableContents> = [
    DSP_INTEGRATION_COMPONENT_TABLE_CONTENTS,
    DSP_TESTING_COMPONENT_TABLE_CONTENTS,
    DSP_REPORTING_COMPONENT_TABLE_CONTENTS,
    DSP_GDPR_DELETED_DEVICE_IDS_API_COMPONENT_TABLE_CONTENTS
]
export const DOCS_LEFT_MENU: DocsMenuSection =
    {
        displayName: 'Documentation',
        id: 'dsp',
        isPage: true,
        url: '/documentation/dsp',
        children: [
            {
                breadcrumbUrl: '/documentation/dsp/integration/',
                displayName: 'Integration',
                id: '_integration',
                isPage: true,
                url: '/documentation/dsp/integration',
                children: [
                ]
            },
            {
                breadcrumbUrl: '/documentation/dsp/reporting/',
                displayName: 'Reporting',
                id: '_reporting',
                isPage: true,
                url: '/documentation/dsp/reporting',
                children: [
                ]
            },
            {
                breadcrumbUrl: '/documentation/dsp/testing',
                displayName: 'Testing',
                id: '_testing',
                isPage: true,
                url: '/documentation/dsp/testing',
                children: [
                ],
            },
            {
                breadcrumbUrl: '/documentation/dsp/viewability',
                displayName: 'Viewability',
                id: '_viewability',
                isPage: true,
                url: '/documentation/dsp/viewability',
                children: [
                ],
            },
            {
                breadcrumbUrl: '/documentation/dsp/creative-specs',
                displayName: 'Creative Format Specifications',
                id: '_creative-specs',
                isPage: true,
                url: '/documentation/dsp/creative-specs',
                children: [
                ],
            },
            {
                breadcrumbUrl: '/documentation/dsp/gdpr-deleted-device-ids-api',
                displayName: 'GDPR Deleted Device IDs API',
                id: '_gdpr_deleted_device_ids_api',
                isPage: true,
                url: '/documentation/dsp/gdpr-deleted-device-ids-api',
                children: [
                ],
            },
            {
                breadcrumbUrl: '',
                displayName: 'Success Stories',
                id: '_success',
                isPage: false,
                url: 'https://www.applovin.com/success-stories/',
                children: []
            },
            {
                breadcrumbUrl: '',
                displayName: 'Help Center',
                id: '_help_center',
                isPage: false,
                url: 'https://www.applovin.com/support/',
                children: []
            },
        ],
    };
